//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { vModel } from 'src/util/mixins';

export default {
	name: 'QDateInput',
	mixins: [vModel('date')],
	props: {
		noManualInput: {
			'type': Boolean,
			'default': false,
		},
	},

};
